import { render, staticRenderFns } from "./AuthFormsWrapper.vue?vue&type=template&id=0907fb2e"
import script from "./AuthFormsWrapper.vue?vue&type=script&lang=js"
export * from "./AuthFormsWrapper.vue?vue&type=script&lang=js"
import style0 from "./AuthFormsWrapper.vue?vue&type=style&index=0&id=0907fb2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports